import React, {Component} from 'react';
import {closeAlert} from "../../actions/commonsActions";
import {SUPER_ADMIN, USER_ROLES} from "../../helpers/constants";
import {connect} from "react-redux";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {
    fetchPromoVideoFolders,
    removePromoVideoFolder,
    removePromoVideoUrl,
    savePromoVideoFolder,
    savePromoVideoUrl,
    updateSinglePromoVideoFolder,
    updateSinglePromoVideoUrl
} from "../../actions/promoVideoActions";
import PromoVideoFolderList from "./PromoVideoFolderList";
import {I18n} from "../../I18n/index";
import swal from "sweetalert";

class PromoVideoCompany extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openFolderIds: [],
        };
    }

    componentDidMount() {
        (async () => await this.fetchData())();
    }

    fetchData = async () => {
        await this.props.fetchPromoVideoFolders({
            companyId: this.getCompany().id
        });
    };

    onOpenFoldersChange = (folderId) => {
        const {openFolderIds} = this.state;
        const updatedOpenFolderIds = openFolderIds.includes(folderId)
            ? openFolderIds.filter(id => id !== folderId)
            : [...openFolderIds, folderId];
        this.setState({openFolderIds: updatedOpenFolderIds});
    }

    getCompany = () => {
        const {company, selectedCompany} = this.props;
        return company ? company : selectedCompany;
    }

    isConflictError = error => error && error.status === 409;

    isNotBlank = text => text && text.trim().length !== 0;

    getSwalWithPlaceholderInInput = () => {
        const {lang} = this.props;
        return swal({
            buttons: {
                cancel: I18n[lang].CANCEL,
                confirm: {
                    closeModal: false
                }
            },
            content: {
                element: "input",
                attributes: {
                    placeholder: I18n[lang].WRITE_SOMETHING,
                },
            },
        })
    }

    getSwalWithTextInInput = inputText => {
        const {lang} = this.props;
        return swal({
            buttons: {
                cancel: I18n[lang].CANCEL,
                confirm: {
                    closeModal: false
                }
            },
            content: {
                element: "input",
                attributes: {
                    value: inputText,
                },
            },
        })
    }

    handleCatchForAdding = (error, conflictErrorMessage, knownErrorPostAction) => {
        const {lang} = this.props;
        if (error) {
            let errorMessage = this.isConflictError(error)
                ? conflictErrorMessage
                : error;
            return swal(errorMessage, "", "error")
                .then(() => setTimeout(() => knownErrorPostAction(), 200));
        } else {
            return swal(I18n[lang].SOMETHING_WENT_WRONG, "", "error")
        }
    }

    addFolder = parentFolderId => {
        const {lang} = this.props;
        this.getSwalWithPlaceholderInInput().then(async folderName => {
            if (this.isNotBlank(folderName)) {
                await this.props.savePromoVideoFolder({
                    name: folderName,
                    companyId: this.getCompany().id,
                    parentFolderId
                }).then(() => {
                    this.fetchData();
                });
            } else if (folderName !== null) {
                throw I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY
            }
            swal.stopLoading();
            swal.close();
        }).catch(error =>
            this.handleCatchForAdding(
                error,
                I18n[lang].FOLDER_WITH_SAME_NAME_ALREADY_EXISTS,
                () => this.addFolder(parentFolderId)
            )
        );
    }

    renameFolder = folder => {
        const {lang} = this.props;
        this.getSwalWithTextInInput(folder.name).then(async updatedName => {
            if (this.isNotBlank(updatedName)) {
                await this.props.updateSinglePromoVideoFolder({
                    id: folder.id,
                    name: updatedName,
                    companyId: folder.companyId,
                    parentFolderId: folder.parentFolderId
                }).then(() => {
                    this.fetchData();
                })
            }
            swal.stopLoading();
            swal.close();
        }).catch(error =>
            this.handleCatchForAdding(
                error,
                I18n[lang].FOLDER_WITH_SAME_NAME_ALREADY_EXISTS,
                () => this.renameFolder(folder)
            )
        )
    };

    deleteFolder = folderId => {
        const {lang} = this.props;
        swal({
            title: I18n[lang].ARE_YOU_SURE,
            buttons: [I18n[lang].NO, I18n[lang].YES],
            icon: "error",
        }).then(async result => {
            if (result) {
                this.props.removePromoVideoFolder(folderId)
                    .then(async result => {
                        if (result && result.status === 'OK') {
                            await this.fetchData();
                        }
                    })
            }
        });
    };

    addUrl = folderId => {
        const {lang} = this.props;
        this.getSwalWithPlaceholderInInput().then(async value => {
            if (this.isNotBlank(value)) {
                await this.props.savePromoVideoUrl({
                    value,
                    folderId
                }).then(() => {
                    this.fetchData();
                });
            } else if (value !== null) {
                throw I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY
            }
            swal.stopLoading();
            swal.close();
        }).catch(error =>
            this.handleCatchForAdding(
                error,
                I18n[lang].SAME_URL_ALREADY_EXISTS_IN_THIS_FOLDER,
                () => this.addUrl(folderId)
            )
        )
    }

    changeUrlValue = url => {
        const {lang} = this.props;
        this.getSwalWithTextInInput(url.value).then(async updatedValue => {
            if (this.isNotBlank(updatedValue)) {
                await this.props.updateSinglePromoVideoUrl({
                    id: url.id,
                    value: updatedValue,
                    folderId: url.folderId
                }).then(() => {
                    this.fetchData();
                })
            }
            swal.stopLoading();
            swal.close();
        }).catch(error =>
            this.handleCatchForAdding(
                error,
                I18n[lang].SAME_URL_ALREADY_EXISTS_IN_THIS_FOLDER,
                () => this.changeUrlValue(url)
            )
        )
    }

    deleteUrl = urlId => {
        const {lang} = this.props;
        swal({
            title: I18n[lang].ARE_YOU_SURE,
            buttons: [I18n[lang].NO, I18n[lang].YES],
            icon: "error",
        }).then(async result => {
            if (result) {
                await this.props.removePromoVideoUrl(urlId)
                    .then(async result => {
                        if (result && result.status === 'OK') {
                            await this.fetchData();
                        }
                    })
            }
        });
    }

    render() {
        const {authority, lang, alert, promoVideoFolders} = this.props;
        const {openFolderIds} = this.state;
        const folderList = promoVideoFolders ?
            <PromoVideoFolderList
                folders={promoVideoFolders}
                addFolder={this.addFolder}
                renameFolder={this.renameFolder}
                deleteFolder={this.deleteFolder}
                addUrl={this.addUrl}
                changeUrlValue={this.changeUrlValue}
                deleteUrl={this.deleteUrl}
                onOpenFoldersChange={this.onOpenFoldersChange}
                openFolderIds={openFolderIds}
            /> : null
        return (
            <div className={authority !== SUPER_ADMIN ? "promo_video_content" : ''}>
                <Alert
                    color={`${alert.alert.status}`}
                    isOpen={alert.isOpen || false}
                >
                    {alert.isOpen ? `${alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-video mr-2"/>
                            {I18n[lang].PROMO_VIDEO}
                            {}
                        </div>
                    </CardTitle>
                    <CardBody>
                        {folderList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPromoVideoFolders: query => dispatch(fetchPromoVideoFolders(query)),
        savePromoVideoFolder: folder => dispatch(savePromoVideoFolder(folder)),
        updateSinglePromoVideoFolder: folder => dispatch(updateSinglePromoVideoFolder(folder)),
        removePromoVideoFolder: folderId => dispatch(removePromoVideoFolder(folderId)),
        savePromoVideoUrl: url => dispatch(savePromoVideoUrl(url)),
        updateSinglePromoVideoUrl: url => dispatch(updateSinglePromoVideoUrl(url)),
        removePromoVideoUrl: urlId => dispatch(removePromoVideoUrl(urlId)),
        closeAlert: () => dispatch(closeAlert())
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    promoVideoFolders: state.promoVideoFoldersReducer.promoVideoFolders,
    company: state.companiesReducer.companies.length > 1 ? null : state.companiesReducer.companies[0],
    tinyCompanies: state.tinyCompaniesReducer.tinyCompanies,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoVideoCompany)



// WEBPACK FOOTER //
// ./src/components/PromoVideo/PromoVideoCompany.js